import React, { useContext, useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import {
    AllCommunityModule,
    ModuleRegistry,
    colorSchemeDark,
    colorSchemeLightCold,
    DateFilterModule,
    themeQuartz
} from 'ag-grid-community';
import { AuthContext, ThemeContext } from '../../../auth';
import { Button } from 'react-bootstrap';
import { BsFillPencilFill } from 'react-icons/bs';
import { ModalTambahCustomer, ModalUbahCustomer } from '../../Modal';
import { useMediaQuery } from 'react-responsive';

function TableCustomer({
    listCustomer,
    retrieveCustomer,
    accessToken
}) {

    const { userInfo } = useContext(AuthContext);
    const isMobile = useMediaQuery({ maxWidth: 736 });
    const { theme } = useContext(ThemeContext);

    const [showAddCustomer, setShowAddCustomer] = useState(false);
    const handleShowAddCustomer = () => {
        setShowAddCustomer(true);
    };

    const [rowSelected, setRowSelected] = useState();
    const [showEditCustomer, setShowEditCustomer] = useState(false);
    const handleShowEditCustomer = (row) => {
        setShowEditCustomer(true);
        setRowSelected(row);
    };

    const [dataTable, setDataTable] = useState([]);

    useEffect(() => {
        const dataTableFilter = listCustomer?.map(({ ...rest }) => rest);

        setDataTable(
            dataTableFilter.map((data) => {
                return {
                    ...data,
                    customerName: data?.title?.titleName === "Others"
                        ? data?.name
                        : `${data?.title?.titleName}. ${data?.name}`,
                    customerTypeName: data?.customerType?.name,
                };
            })
        );
    }, [listCustomer]);

    ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule]);

    const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);
    const themecolorSchemeDark = themeQuartz.withPart(colorSchemeDark);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (dataTable && dataTable.length > 0) {
            setRowData(dataTable);
        }
    }, [dataTable]);

    const colDefs = [
        {
            field: "customerName",
            headerName: "Nama Customer",
            sortable: true,
            sort: 'asc',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.customerName}
                    </div>
                );
            },
        },
        {
            field: "contactPerson",
            headerName: "Contact Person",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.contactPerson}
                    </div>
                );
            },
        },
        {
            field: "email",
            headerName: "Customer Email",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.email}
                    </div>
                );
            },
        },
        {
            field: "customerTypeName",
            headerName: "Tipe Customer",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.customerTypeName}
                    </div>
                );
            },
        },
        {
            field: 'ubah',
            headerName: 'Ubah',
            width: 100,
            pinned: 'right',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => handleShowEditCustomer(row.data)}
                    >
                        <Button
                            variant='btn'
                            onClick={() => handleShowEditCustomer(row.data)}
                        >
                            &nbsp;<BsFillPencilFill size={20} color={theme == 'light' ? '#12B3ED' : '#006CB8'} />&nbsp;
                        </Button>
                    </div>
                );
            },
        },
    ];

    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true
    };

    const [tableHeight, setTableHeight] = useState(window.innerHeight - 200); // Initial height

    useEffect(() => {
        const updateHeight = () => {
            setTableHeight(window.innerHeight - 200); // Adjust as needed
        };

        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return (
        <div style={{ height: tableHeight }}>

            {userInfo?.role?.roleName === 'Admin' ?
                (
                    <>
                        <Button
                            id={theme === 'light' ? 'actionButtonTabelDark' : 'actionButtonTabelLight'}
                            variant='btn'
                            style={{ color: theme === 'light' ? '#222' : 'white', fontSize: '14px' }}
                            onClick={handleShowAddCustomer}
                        >
                            Tambah
                        </Button>
                    </>
                )
                :
                (
                    <></>
                )
            }
            <AgGridReact
                theme={theme === "light" ? themecolorSchemeDark : themeLightCold}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                pagination={isMobile ? false : true}
                rowHeight={30}
            />

            <ModalUbahCustomer
                rowSelected={rowSelected}
                showEditCustomer={showEditCustomer}
                setShowEditCustomer={setShowEditCustomer}
                retrieveCustomer={retrieveCustomer}
                accessToken={accessToken}
            />

            <ModalTambahCustomer
                showAddCustomer={showAddCustomer}
                setShowAddCustomer={setShowAddCustomer}
                retrieveCustomer={retrieveCustomer}
                accessToken={accessToken}
            />
        </div>
    )
}

export default TableCustomer
